"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumber = exports.isEmpty = exports.isBooleanValue = exports.isNullOrUndefined = void 0;
const isNullOrUndefined = (value, includeEmptyString) => value === null ||
    value === undefined ||
    (includeEmptyString && value === '') ||
    false;
exports.isNullOrUndefined = isNullOrUndefined;
const isBooleanValue = (value) => typeof value === 'boolean';
exports.isBooleanValue = isBooleanValue;
const isEmpty = (value) => value == null || value.length === 0;
exports.isEmpty = isEmpty;
const isNumber = (val) => !isNaN(parseFloat(val));
exports.isNumber = isNumber;
